/* eslint no-return-assign: 0 */
import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import classNames from 'classnames'
import { Link } from 'react-router-dom'

import CATEGORY_COMPONENT_ITEM_FRAGMENT from '../../../graphql/fragments/category.gql'
import { useRentalPageDetector } from '../../hooks/use-rental-page-detector'
import styles from './category-navigation-tabs.css'

const CategoryNavTabs = ({
  categoryItems: tabs,
  selectedCategory,
  onTotalTabWidths,
  selectKeyValue
}) => {
  const tabReferences = useRef({})
  const isOnARentalThemedPage = useRentalPageDetector()
  const [selectedTab, setSelectedTab] = useState(selectedCategory)
  const selectedIndex = tabs.indexOf(selectedTab)

  const getTotalTabWidths = () => {
    let total = 0

    tabs.forEach(tab => {
      const tabRef =
        tabReferences.current && tabReferences.current[`tab-${tab.id}`]
      if (!tabRef) return

      const tabWidth = tabRef.getBoundingClientRect().width
      total += Math.floor(tabWidth)
    })

    return total
  }

  useEffect(() => {
    const totalTabWidths = getTotalTabWidths()
    onTotalTabWidths(totalTabWidths)
  }, [])

  return (
    <div className={styles.wrapper}>
      {tabs.map((tab, i) => {
        return (
          <span
            key={tab.id}
            className={styles.category}
            onClick={() => setSelectedTab(tab)}
            ref={ref => (tabReferences.current[`tab-${tab.id}`] = ref)}
          >
            <Link
              className={classNames(styles.tab, {
                [styles.selected]: selectedIndex === i,
                [styles.isRental]: isOnARentalThemedPage
              })}
              to={tab.path || '/404'}
            >
              {tab[selectKeyValue]}
            </Link>
          </span>
        )
      })}
    </div>
  )
}

CategoryNavTabs.propTypes = {
  categoryItems: PropTypes.arrayOf(propType(CATEGORY_COMPONENT_ITEM_FRAGMENT))
    .isRequired,
  selectedCategory: propType(CATEGORY_COMPONENT_ITEM_FRAGMENT).isRequired,
  onTotalTabWidths: PropTypes.func.isRequired,
  selectKeyValue: PropTypes.string.isRequired
}

export default CategoryNavTabs
